export const GROUP_COLORS = {
  umber: '#8b5d45',
  sky: '#56b9dc',
  violet: '#a65bc2',
  orange: '#e9903a',
  coral: '#df6357',
  sun: '#edc849',
  green: '#3c9c6d',
  navy: '#315d9b',
  transport: '#334b5f',
  utility: '#7b9299',
};

export const TOKEN_LABELS = {
  rocket: 'Ракета',
  boat: 'Катер',
  bicycle: 'Велосипед',
  cat: 'Кот',
  globe: 'Глобус',
  tree: 'Дерево',
};

export function gridPosition(position) {
  if (position === 0) return { row: 11, column: 11 };
  if (position < 10) return { row: 11, column: 11 - position };
  if (position === 10) return { row: 11, column: 1 };
  if (position < 20) return { row: 21 - position, column: 1 };
  if (position === 20) return { row: 1, column: 1 };
  if (position < 30) return { row: 1, column: position - 19 };
  if (position === 30) return { row: 1, column: 11 };
  return { row: position - 29, column: 11 };
}

export function formatMoney(value) {
  return new Intl.NumberFormat('ru-RU').format(value);
}

export function cellIcon(type) {
  return {
    start: '➜',
    chance: '?',
    community: '✦',
    tax: '%',
    transport: '▰',
    utility: '⚡',
    jail: '▦',
    parking: '♧',
    goToJail: '⇢',
  }[type] ?? '';
}
